import { render } from "./DesignTable.vue?vue&type=template&id=166f1389"
import script from "./DesignTable.vue?vue&type=script&lang=js"
export * from "./DesignTable.vue?vue&type=script&lang=js"

import "./DesignTable.vue?vue&type=style&index=0&id=166f1389&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__